import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileCard from "../ui/ProfileCard";
import ProfileTab from "../ui/ProfileTab";
import { useStateContext } from "../context/index";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getUserFn } from "../APIServices/Services";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Spinner from "../ui/Spinner";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

export default function Profile() {
  const { state } = useStateContext();
  const { data, isError, error, isLoading } = useQuery(
    ["authUser"],
    getUserFn,
    {
      staleTime: 2000,
      keepPreviousData: true,
    }
  );
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("md"));
  const matchesXS = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesMD = useMediaQuery(theme.breakpoints.down("lg"));
  console.log(state)

  if (isLoading) {
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <CssBaseline />
      <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
        <Spinner />
      </Container>
    </Box>;
  }
  if (isError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            Oops, something went wrong
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {error.toString()}
          </Typography>
        </Container>
      </Box>
    )
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid sm item>
          <ProfileCard details={data} />
        </Grid>
        <Grid sm item>
          <ProfileTab />
        </Grid>
      </Grid>
    </Box>
  );
}
